import { render, staticRenderFns } from "./UserCardForm.vue?vue&type=template&id=0885f58d"
import script from "./UserCardForm.vue?vue&type=script&lang=js"
export * from "./UserCardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports